import * as React from "react";
import styled from "styled-components";
import Badge, { StyledBadge } from "../Badge";
import defaultTheme from "../defaultTheme";
import { TYPE_OPTIONS } from "../Badge/consts";
var StyledNotificationBadge = styled.div.withConfig({
  displayName: "NotificationBadge__StyledNotificationBadge",
  componentId: "zl2bxd-0"
})(["", "{width:", ";padding:0;}"], StyledBadge, function (_ref) {
  var theme = _ref.theme;
  return theme.orbit.widthBadgeCircled;
});
StyledNotificationBadge.defaultProps = {
  theme: defaultTheme
};

var NotificationBadge = function NotificationBadge(props) {
  var _props$type = props.type,
      type = _props$type === void 0 ? TYPE_OPTIONS.NEUTRAL : _props$type,
      children = props.children,
      icon = props.icon,
      ariaLabel = props.ariaLabel,
      dataTest = props.dataTest;
  return React.createElement(StyledNotificationBadge, null, React.createElement(Badge, {
    type: type,
    dataTest: dataTest,
    icon: icon,
    ariaLabel: ariaLabel
  }, !icon && children));
};

export default NotificationBadge;